// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/mic.js';

import { paths } from '../generated/mic';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('mic', Original, paths);
